import { Button, Typography } from "@mui/material";
/* eslint-disable max-len */
import React, { useEffect } from "react";

import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { MODALS } from "../../../config/params";
import { useModal } from "../../../context/ModalContext";
import { useUserDelete } from "../../../services/user-delete/user-delete.service";
import { useUserStatusStore } from "../../../hooks/redux-hooks/user-status/user-status.store";
import { userActivityLogger } from "../../../utils/mixpanel";

const UserDeleteModal = () => {
  const { userDelete, userDeleted } = useUserDelete();
  const { emailSignIn } = useUserStatusStore();
  const { closeModal, openModal } = useModal();


  const handleDelete = () => {
    if (emailSignIn) {
      userActivityLogger(MIXPANEL_EVENTS.DELETE_ACCOUNT, {});
      userDelete(emailSignIn);
    }
  };

  useEffect(() => {
    if (userDeleted?.deleted) {
      openModal(MODALS.USER_DELETE_REDIRECT);
    }
  }, [userDeleted]);

  return (
    <div className="flex flex-col gap-6 justify-between p-6 h-[95%] overflow-auto">
      <div className="flex flex-col gap-3 self-stretch flex-1">
        <img
          alt="tennis ball"
          src="/assets/icons/TennisBall.png"
          className="max-w-8 w-8"
        />
        <Typography className="font-semibold !text-2xl">Delete Account?<br/>
          We’re sorry to see you go!</Typography>
        <Typography variant="h4">By deactivating your Good Vets digital account, you will be logged out and you will lose access to the GoodVets digital applications and all their features. If you have connected your GoodVets digital account to any third party platforms, deactivating your account will remove all of your GoodVets data from such platforms. While you will no longer be able to access your GoodVets digital account, GoodVets will retain and may use your pet&apos;s medical records and other associated account information as necessary to comply with our legal obligations and resolve disputes.<br/><br/>
        If you have any feedback on why you&apos;ve decided to deactivate your GoodVets account, we&apos;d be grateful if you shared it with us <strong>feedback@goodvets.com</strong></Typography>
      </div>

      <div className="flex flex-col gap-2 self-stretch">
        <Button fullWidth className="!normal-case !border !border-taupe-2 !bg-gray-3 hover:!text-black"
          onClick={handleDelete}>Delete Account</Button>
        <Button fullWidth className="!normal-case !border !border-taupe-2 !bg-white hover:!text-black"
          onClick={closeModal}>Cancel</Button>
      </div>
    </div>
  );
};

export default UserDeleteModal;
